import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN, {
    debug: true,
    track_pageview: false,
    persistence: 'localStorage',
});

export const identifyUser = ({ id, name, email }) => {
    mixpanel.identify(id);
    mixpanel.people.set({
        $name: name,
        $email: email,
    });
};

export const trackEvent = (event, props = {}) => {
    mixpanel.track(event, props);
};

export const incrementTimeSpent = (seconds) => {
    mixpanel.people.increment('total_time_spent', seconds);
};

export default mixpanel;
